import { render, staticRenderFns } from "./KlasusLevel1.vue?vue&type=template&id=55c7ff85&scoped=true"
import script from "./KlasusLevel1.vue?vue&type=script&lang=js"
export * from "./KlasusLevel1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c7ff85",
  null
  
)

export default component.exports